let lenisInstance = null;

export const setLenis = (instance) => {
  lenisInstance = instance;
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (el) {
    if (lenisInstance) {
      lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
    return;
  }
  if (window.location.pathname !== "/") {
    sessionStorage.setItem("rk_scroll_to", id);
    window.location.href = "/";
  }
};
